import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';

export const recipeService = {
  getAll,
  getAllDeleted,
  getMyRecipes,
  getSubRecipes,
  getMySharedRecipes,
  getRecipeVariations,
  getById,
  searchRecipes,
  addRecipe,
  updateRecipe,
  removeRecipe,
  cloneRecipe
};

function getAll(params) {
  const requestOptions = {
      method: 'GET',
      headers: authHeader(),
  };
  var ps = "";
  var ccat = "";
  if(params.page)
  {
    ccat = "&";
    ps = ps + "pageNumber=" + params.page;
  }
  if(params.pageSize)
  { 
    ccat = "&";
    ps = ps + ccat + "pageSize=" + params.pageSize;
  }
  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes?${ps}`, requestOptions)
          .then(handleResponse)
          .catch(err => {
                throw err;
            });
}

function getAllDeleted() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes`, requestOptions).then(handleResponse);
}

function getById(id,lang) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${id}?lang=${lang}`, requestOptions).then(handleResponse);
}

function getSubRecipes(recipeId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  
  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${recipeId}/subrecipes`, requestOptions).then(handleResponse);
}

function getMyRecipes(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  var ps = "";
  var ccat = "";
  if(params && params.query)
  {
    ps = ps + ccat + "searchQuery=" + params.query;
    ccat = "&";
  }
  if(params.page)
  {
    ps = ps + ccat + "pageNumber=" + params.page;
    ccat = "&";
  }
  if(params.pageSize)
  { 
    ps = ps + ccat + "pageSize=" + params.pageSize;
    ccat = "&";
  }
  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${params.userId}/myrecipes?${ps}`, requestOptions)
    .then(handleResponse)
    .catch(err => {
        throw err;
    });
}

function getMySharedRecipes(userId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${userId}/sharedrecipes`, requestOptions).then(handleResponse);
}

function getRecipeVariations(recipeId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${recipeId}/variations`, requestOptions).then(handleResponse);
}

function searchRecipes(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  var ps = "";
  var ccat = "";
  if(params && params.query)
  {
    ps = ps + "searchQuery=" + params.query;
    ccat = "&";
  }
  if(params && params.brandId)
  { 
    ps = ps + ccat + "brandId=" + params.brandId;
    ccat = "&";
  }
  if(params && params.chefId)
  { 
    ps = ps + ccat + "chefId=" + params.chefId;
    ccat = "&";
  }
  if(params && params.tagId)
  { 
    ps = ps + ccat + "tagId=" + params.tagId;
    ccat = "&";
  }
  if(params && params.collectionId)
  { 
    ps = ps + ccat + "collectionId=" + params.collectionId;
    ccat = "&";
  }
  if(params && params.ingredientId)
  {
    ps = ps + ccat + "ingredientId=" + params.ingredientId;
    ccat = "&";
  }
  if(params && params.operatorId)
  { 
    ps = ps + ccat + "operatorId=" + params.operatorId;
    ccat = "&";
  }
  if(params && params.pageSize)
  { 
    ps = ps + ccat + "pageSize=" + params.pageSize;
    ccat = "&";
  }
  if(params && params.page)
  {
    ps = ps + ccat + "pageNumber=" + params.page;
    ccat = "&";
  }
  if(params && params.statusCode)
  {
    ps = ps + ccat + "statusCode=" + params.statusCode;
    ccat = "&";
  }

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes?${ps}`, requestOptions).then(handleResponse);
}
function addRecipe(newRecipe) {
  const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: JSON.stringify(newRecipe)
  };
  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes`, requestOptions)
      .then(handleResponse)
      .then(recipe => {
          return recipe;
      }).catch(function (err) {
          return Promise.reject(err);
      });
}
async function updateRecipe(newRecipe) {
  const requestOptions = {
      method: 'PUT',
      headers: authHeader(),
      body: JSON.stringify(newRecipe)
  };
  var resp = await fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${newRecipe.id}`, requestOptions)
      .then(handleResponse)
      .then(recipe => {
          return recipe;
      }).catch(function (err) {
          return Promise.reject(err);
      });
}

function removeRecipe(id) {
  const requestOptions = {
      method: 'DELETE',
      headers: authHeader(),
      body: JSON.stringify(id)
  };
  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${id}`, requestOptions)
      .then(handleResponse)
      .then(response => {
          return response;
      });
}

function cloneRecipe(params) {
  const requestOptions = {
      method: 'GET', 
      headers: authHeader()
  };
  var resp = fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${params.id}/clone?lang=${params.lang}`, requestOptions)
      .then(handleResponse)
      .then(response => {
          return response;
      }).catch(function (err) {
        console.log(err);
        return Promise.reject(err);
    });
  return resp;
}
